import {AbstractVisionKey} from './AbstractVisionKey';

export class VisionFilterKey extends AbstractVisionKey {}

